import classNames from 'classnames'

import { t } from '../../../common/i18n.js'
import { Language } from '../../../common/types/i18n.js'
import { PlaytimeUserBadge } from '../../../common/types/playtime.js'
import { BadgeArt, restBadgeArtWithin, tiltBadgeArtWithin } from '../badge-art/badge-art.js'
import './badge-card.scss'

export interface BadgeCardProps {
    badge: PlaytimeUserBadge
    lang: Language
    onClick?: () => void
}

export const BadgeCard = ({ badge, lang, onClick }: BadgeCardProps) => {
    const b = t.playtime.badges
    const isClaimed = badge.status === 'claimed'
    const isPending = badge.status === 'pending'
    const flag = isPending
        ? { text: b.pending(lang), modifier: 'pending' }
        : badge.is_new
          ? { text: b.newFlag(lang), modifier: 'new' }
          : null

    return (
        <button
            type="button"
            className={classNames('badge-card', !isClaimed && 'badge-card--inactive')}
            onClick={onClick}
            // The whole card tilts the badge (prototype tilt-scope=".card")
            onPointerMove={
                isClaimed
                    ? (e) => tiltBadgeArtWithin(e.currentTarget, e.clientX, e.clientY)
                    : undefined
            }
            onPointerLeave={isClaimed ? (e) => restBadgeArtWithin(e.currentTarget) : undefined}
            aria-label={`${badge.name}, ${b.score(badge.score)(lang)}, ${b.tier[badge.art.tier](lang)}`}
        >
            <span className="badge-card__art">
                <BadgeArt
                    art={badge.art}
                    state={isClaimed ? 'active' : 'slot'}
                    idPrefix={`card${badge.id}`}
                    tilt={isClaimed ? 'scope' : undefined}
                />
                {flag && (
                    <span className={`badge-card__flag badge-card__flag--${flag.modifier}`}>
                        {flag.text}
                    </span>
                )}
            </span>
            <span className="badge-card__name">{badge.name}</span>
            <span className="badge-card__meta">
                <i
                    className={`badge-card__tier badge-card__tier--${badge.art.tier}`}
                    aria-hidden="true"
                />
                {b.score(badge.score)(lang)}
            </span>
            {badge.is_special && <span className="badge-card__chip">{b.special(lang)}</span>}
        </button>
    )
}
